import { TmElement, reset, color, rem, label } from '@thiememeulenhoff/lit-sdk';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tagName } from '../../../helpers';

const tag = tagName('toggle-indicator');

@customElement(tag)
export class ToggleIndicatorComponent extends TmElement {
  static override styles = [
    reset.button,
    css`
      :where(*) {
        box-sizing: border-box;
      }

      :host {
        align-items: center;
        background-color: ${color('white', 200)};
        border-radius: ${rem(4)};
        color: ${color('grey', 600)};
        display: flex;
        ${label('small')};
        justify-content: center;
        min-block-size: ${rem(16)};
        min-inline-size: ${rem(16)};
      }

      :host([active]) {
        background-color: ${color('beige', 200)};
      }
    `,
  ];

  @property({ type: Boolean, reflect: true })
  active = false;

  setActive(active: boolean) {
    this.active = active;
  }

  override render() {
    return html` <slot></slot> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-toggle-indicator': ToggleIndicatorComponent;
  }
}
